module.exports = __webpack_public_path__ + "static/media/video_playbutton.ac631a8b.svg";